import ButtonSubmitPaypal from './ButtonSubmitPaypal';
export default ButtonSubmitPaypal;
